import { z } from 'zod'

/**
 * Crockford base32, 26 characters, first character capped at 7 because the
 * 48-bit timestamp cannot overflow past that until the year 10889.
 */
export const ULID_PATTERN = /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/

export const ulidSchema = z.string().regex(ULID_PATTERN, 'Not a valid id.')

/**
 * Cursors are ULIDs, not offsets. A ULID sorts by creation time, so a row
 * inserted while the trader is paging cannot shift every later row down by one
 * and make them re-read — or skip — an animal. `?limit=25&cursor=<ULID>`.
 */
export const cursorQuerySchema = z.object({
  // Query strings arrive as text, hence the coercion; the ceiling is a real
  // ceiling, not a clamp, so an over-large page is a caller bug we report.
  limit: z.coerce.number().int().min(1).max(100).default(25),
  cursor: ulidSchema.optional(),
})

export type CursorQuery = z.infer<typeof cursorQuerySchema>
